import { Box } from "@mui/material"
import { useSelector } from "react-redux"
import { AppState } from "../../core/app/AppReducer"
import FireMedallionItem from "../inventory/medallions/FireMedallionItem"
import ForestMedallionItem from "../inventory/medallions/ForestMedallionItem"
import LightMedallionItem from "../inventory/medallions/LightMedallionItem"
import ShadowMedallionItem from "../inventory/medallions/ShadowMedallionItem"
import SpiritMedallionItem from "../inventory/medallions/SpiritMedallionItem"
import WaterMedallionItem from "../inventory/medallions/WaterMedallionItem"
import { isNil } from "lodash"

const Trials = [
    ForestMedallionItem,
    FireMedallionItem,
    WaterMedallionItem,
    ShadowMedallionItem,
    SpiritMedallionItem,
    LightMedallionItem
]
interface TrialTrackerProps {
    useRedux?: boolean,
    useLabel?: boolean,
    layout?: "horizontal" | "stack"
}
const TrialTracker = (props: TrialTrackerProps) => {

    let useTrials = useSelector((state: AppState) => state.ui.ootr.main.useTrials)

    if (!useTrials && (isNil(props.useRedux) || props.useRedux))
        return null;

    return <Box display="flex" flexWrap={"wrap"} flexDirection={"column"} textAlign={"center"}>
        <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} width={"100%"} >
            {(isNil(props.useLabel) || props.useLabel) && <Box component="h3" textAlign={"center"} marginRight={2}>Trials</Box>}
            <Box display={"flex"} flexDirection={"row"} flexWrap={"wrap"} maxWidth={isNil(props.layout) || props.layout === "stack" ? 120 : 800}>
            {Trials.map(t => {
                return <Box display={"flex"} marginRight={1}>
                    {t({ hideLabel: true })}
                </Box>
            })}</Box>
        </Box>
    </Box>
}

export default TrialTracker